import * as React from 'react';
export const Checkbox = ({ label, input, id, checked, meta: { touched, error } }) => {
  return (
    <div className="form-check">
      <label className="form-check-label" htmlFor={id}>
        <input {...input} checked={checked ? checked : input.checked} className="form-check-input" type="checkbox" />
        {label}
      </label>
    </div>
  );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/_global/components/form-elements/checkbox.tsx